<template>
	<div class="p_box" id="box">
		<div id="head">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/Homes' }" replace>首页</el-breadcrumb-item>
				<el-breadcrumb-item :to="{ path: '/NewsSt' }" replace>消息</el-breadcrumb-item>
				<el-breadcrumb-item >提问老师</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class=" p_m_t_30 mine_list overflow small_hand" :style="{ height: height + 'px' }">
			<div class=" " >
				<error-deatil></error-deatil>
			</div>
			<!-- <div class="mine_list" style="height: 38%;margin-top: 1%;">
				<error-input></error-input>
			</div> -->
		</div>
	</div>
</template>

<script>
import ErrorDeatil from './commponents/errorDeatil.vue'
import ErrorInput from './commponents/errorInput.vue'
export default {
	name: 'Students',
	components:{
		ErrorDeatil,
		ErrorInput
	},
	data() {
		return {
			height: 0
		};
	},
	mounted() {
		this.indexInfo();
	},
	watch: {
		'$route.path': {
			immediate: true,
			handler(newVal, oldVal) {
				if (newVal == '/Students') {
					var height = localStorage.getItem('height');
					if (height == '') {
					} else {
						this.height = height;
					}
				}
			}
		}
	},
	beforeRouteLeave(to, form, next) {
		localStorage.removeItem('height');
		next();
	},
	methods: {
		indexInfo() {
			var box = document.getElementById('box').offsetHeight;
			var head = document.getElementById('head').offsetHeight;
			var height = box - head  - 30;
			var heights = localStorage.getItem('height');
			if (heights == null) {
				localStorage.setItem('height', height);
			} else {
			}
			this.height = height;
		},
	}
};
</script>

<style lang="scss" scoped>
	.mine_list{
		background: #FFFFFF;
	}
</style>



// WEBPACK FOOTER //
// src/components/homes/news/student.vue